<div class="job-data font-regular font-weight-normal">
  <span
    class="title"
    data-cy="job-card-title"
  >
    <common-mojo-mark-search-phrase-box
      [markedSearchPhrase]="markedSearchPhrase"
      [text]="job.title"
    >
    </common-mojo-mark-search-phrase-box>
  </span>
  <span class="details">
    <span>{{ job.id }}</span>
    <span
      *mojoHasFeatureExtension="externalSystemInformation">{{ job.externalDisplayId }}</span>
    <span *ngIf="job.clientReqId">
      <common-mojo-mark-search-phrase-box
        [markedSearchPhrase]="markedSearchPhrase"
        [text]="job.clientReqId"
      >
      </common-mojo-mark-search-phrase-box>
    </span>
    <span>{{ job.company?.name }}</span>
    <mojo-job-location
      [showTooltip]="false"
      [locations]="job.locations"
    >
    </mojo-job-location>
  </span>
  <mojo-status
    [status]="job.status"
    [statusFilterType]="statusFilterType"
    data-cy="job-item-status"
  ></mojo-status>
</div>
